export const DEFAULT_EPISODE = "bc25java";
export const FIELD_REQUIRED_ERROR_MSG = "This field is required.";
